<template>
        <el-dialog title="VipBodyguards" :visible.sync="showPopup" class="my-dialog-class" >
        <el-form label-position="top" :inline="false" :rules="rules" label-width="100%"  :model='selectedObject'  ref='my-form' @submit.prevent="save" v-loading="loadingVisible" >
            <el-row :gutter="15" >
                
            <el-col :md='8'>
                <el-form-item label='Name' >
                    <el-input  class='full-width' v-model='selectedObject.Name' />
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item label='Description' >
                    <el-input  class='full-width' v-model='selectedObject.Description' />
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item label='Email' >
                    <el-input  class='full-width' v-model='selectedObject.Email' />
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item label='PhoneNumber' >
                    <el-input  class='full-width' v-model='selectedObject.PhoneNumber' />
                </el-form-item>
            </el-col>
            <el-col :md='24'>
                <el-form-item label='ImageFile' >
                <el-upload
                        class='my-uploader'
                        :action="baseUrl + 'Vipbodyguards/upload_ImageFile'"
                        :show-file-list='false'
                        :on-success='handleUploadSuccess_ImageFile'>
                            <i class='el-icon-plus my-uploader-icon'></i>
                        </el-upload>       <img v-if='selectedObject.uploadPreview_ImageFile' :src='selectedObject.uploadPreview_ImageFile' > 
                </el-form-item>
            </el-col>            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer" >
            <el-button @click="showPopup=false"     > Renunta  </el-button>
            <el-button type="primary" @click="save" > Salveaza </el-button>
        </span>
    </el-dialog>
</template>

<script>
    import settings from "@/backend/LocalSettings";
    import BasePage from '@/pages/BasePage';

    export default {
        name: "Vipbodyguards_dialog",
        extends: BasePage,
        data () {
            return {
                baseUrl :'',
                showPopup: false,
                mode: 'add',
                selectedObject: {
                    Name: '' , Description: '' , Email: '' , PhoneNumber: '' , ImageFile: '' , uploadPreview_ImageFile : '' ,                 },
                Info:{
                                    },
                rules: {
                    //   Nume: [ { required: true, message: "Campul este obligatoriu" } ]
                    Name: [ { required: true, message: 'Campul este obligatoriu' } ], 
Description: [ { required: true, message: 'Campul este obligatoriu' } ], 
Email: [ { required: true, message: 'Campul este obligatoriu' } ], 
PhoneNumber: [ { required: true, message: 'Campul este obligatoriu' } ], 
ImageFile: [ { required: true, message: 'Campul este obligatoriu' } ], 
                }
            }
        },
        methods: {
            show_me: async function( id ) {
                this.showPopup        = true;
                if( id == null )
                {
                    this.mode = "add";
                }
                else
                {
                    this.mode             = "edit";
                    var            result = await this.post("vipbodyguards/get_info_item_dialog", { id: id } );
                    this.selectedObject   = result.Item;
                }
            },
            async get_info(){
                var response = await this.post("vipbodyguards/get_info_for_dialog" );
                            },
             handleUploadSuccess_ImageFile(response){
                    this.selectedObject.ImageFile = response.FileName;
                    this.selectedObject.uploadPreview_ImageFile  = response.Url;
                },
                    save: async function() {
                this.$refs['my-form'].validate( async(valid) => {
                    if (valid)
                    {
                        await this.post("vipbodyguards/save", { mode: this.mode, object: this.selectedObject } );
                        this.showPopup = false;
                        this.$emit("save");
                    }
                });
            }
        },
        mounted: function() {
            this.baseUrl = settings.BASE_URL;
            this.get_info();
        }
    };
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }

</style>